import React, { ReactNode } from "react";
import { CardContent, useTheme } from "@mui/material";
import { Theme } from "@emotion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Content } from "@iventis/translations/content/typed-content";
import { borderRadius, Caption, Header3, InteractiveElement, styled } from "@iventis/styles";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";

export const CardHeader: React.FC<{ title: ReactNode; subTitle: string; canEditSession: boolean; onClose: () => void; onEdit: () => void }> = ({
    title,
    subTitle,
    canEditSession,
    onClose,
    onEdit,
}) => {
    const translate = useIventisTranslate();
    const theme = useTheme<Theme>();
    return (
        <>
            <ExitButton style={{ color: theme.secondaryColors.blank }} onClick={onClose}>
                <span className="hidden">{translate(Content.schedule.session_card.close_popup)}</span>
                <FontAwesomeIcon icon={["fal", "xmark"]} />
            </ExitButton>
            <StyledHeader>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Caption style={{ opacity: "0.8" }}>{subTitle}</Caption>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Header3>{title}</Header3>
                    {canEditSession && (
                        <InteractiveElement className="edit-button" onClick={onEdit}>
                            {translate(Content.schedule.session_card.edit)}
                        </InteractiveElement>
                    )}
                </div>
            </StyledHeader>
        </>
    );
};

const ExitButton = styled(InteractiveElement)`
    border-radius: ${borderRadius.circle};
    position: absolute;
    top: 0;
    right: 0;
    padding: 7px 11px;
    margin: 5px;
    color: ${({ theme }: { theme: Theme }) => theme.typographyColors.blank};
    :hover {
        background-color: rgba(255, 255, 255, 0.075);
    }
`;

const StyledHeader = styled(CardContent)`
    background-color: ${({ theme }: { theme: Theme }) => theme.primaryColors.subdued50};
    color: ${({ theme }: { theme: Theme }) => theme.typographyColors.blank};

    .edit-button {
        text-decoration: underline;
        align-self: end;
        letter-spacing: 0.5px;
    }
`;
